import React from 'react'
import AboutHero from '../about/about-hero'
import AboutWhat from '../about/about-what2'
import { useGetPrivacyPolicyQuery } from 'src/store/Reducer/legal'

const PrivacyPolicyView = () => {
    const { data } = useGetPrivacyPolicyQuery();
    //  image: `${process.env.PUBLIC_URL}/assets/privacy-policy.jpeg`
    return (
        <div>
            <AboutHero data={{ title: "Our", list: ["Privacy Policy"] }} />
            <AboutWhat data={{ title: "", content: data?.data?.content }} />
        </div>
    )
}

export default PrivacyPolicyView;


const data = {
    "data": { "text": "<h2>Privacy Policy</h2>\n<p>Your privacy is important to us. It is [Your Company Name]'s policy to respect your privacy regarding any information we may collect from you across our website, [Your Website URL], and other sites we own and operate.</p>\n<p>We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.</p>" }
}
